module.exports = __webpack_public_path__ + "static/media/AU.09d26e46.png";